import getCookie from '@helpers/getCookie.js';
import setCookie from '@helpers/setCookie.js';

function isRobot () {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') { return true; }

  const userAgent = navigator.userAgent || null;
  if (!userAgent) {
    return true;
  }
  return (
    userAgent === 'Mediapartners-Google' ||
    userAgent.indexOf('AdsBot-Google') !== -1
  );
}

function getReferrer () {
  const referrer = document.referrer;

  if (!referrer || ~referrer.indexOf(document.location.host)) {
    return { value: 'direct', is_search_engine: false };
  }

  if (~referrer.indexOf('.google.com')) {
    return { value: 'google', is_search_engine: true };
  }
  if (~referrer.indexOf('.bing.com')) {
    return { value: 'bing', is_search_engine: true };
  }
  if (~referrer.indexOf('.yahoo.com')) {
    return { value: 'yahoo', is_search_engine: true };
  }
  return { value: referrer, is_search_engine: false };
}

function getReferal (callback) {
  const searchParams = new URL(document.location.href).searchParams;
  const oldReferal = getCookie('referal');
  const source =
    searchParams.get('utm_source') ||
    searchParams.get('referal') ||
    searchParams.get('referral') ||
    searchParams.get('referraltype');

  if (source) {
    // setCookie
    setCookie('referal', source, 1);
    setCookie('utm_source', source, 1);
    setCookie('utm_medium', searchParams.get('utm_medium'), 0);
    typeof callback === 'function' && callback();
    return source;
  }

  const referrer = getReferrer();
  if (referrer.is_search_engine) {
    if (!oldReferal || oldReferal === 'direct') {
      // setCookie
      setCookie('referal', referrer.value, 1);
      setCookie('utm_source', referrer.value, 1);
      setCookie('utm_medium', 'organic', 1);
      typeof callback === 'function' && callback();
      return referrer.value;
    }
    return oldReferal;
  }

  if (referrer.value !== 'direct') {
    if (!oldReferal || oldReferal === 'direct') {
      // setCookie
      setCookie('referal', referrer.value, 1);
      setCookie('utm_source', referrer.value, 1);
      setCookie('utm_medium', searchParams.get('utm_medium'), 0);
      typeof callback === 'function' && callback();
      return referrer.value;
    }
    return oldReferal;
  }

  if (!oldReferal) {
    // setCookie
    setCookie('referal', 'direct', 1);
    setCookie('utm_source', 'direct', 1);
    setCookie('utm_medium', searchParams.get('utm_medium'), 0);
    typeof callback === 'function' && callback();
    return 'direct';
  }

  return oldReferal;
}

(function () {
  if (isRobot()) {
    return;
  }

  const searchParams = new URL(document.location.href).searchParams;

  const dataLayer = {};
  const promocode = searchParams.get('promocode');

  if (promocode) {
    setCookie('promocode', promocode);
    dataLayer.promocode = promocode;
  }

  let updateTracking = false;

  [
    'utm_source',
    'utm_content',
    'utm_campaign',
    'utm_term',
    'utm_medium'
  ].forEach((utmParamName) => {
    const utmParamValue = searchParams.get(utmParamName);
    if (utmParamValue) {
      setCookie(utmParamName, utmParamValue);
      dataLayer[utmParamName] = utmParamValue;
      updateTracking = true;
    }
  });

  dataLayer.referal = getReferal(() => (updateTracking = true));
  dataLayer.utm_source = dataLayer.referal;
  dataLayer.utm_medium = getCookie('utm_medium') || null;

  if (updateTracking || !getCookie('tracking')) {
    const trackingService = new URL(
      '/rest/media/tracking',
      document.location.origin
    );
    Object.keys(dataLayer).forEach((key) =>
      trackingService.searchParams.append(
        key,
        (dataLayer[key] || '').substr(0, 40)
      )
    );

    fetch(trackingService)
      .then((response) => response.json())
      .then((trackingID) => {
        setCookie('tracking', trackingID, 1);
      });
  }

  if (window.dataLayer) {
    window.dataLayer.push(dataLayer);
  }
})();
